import axios from 'axios';

export const axiosPublicInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const axiosPrivateInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 30_000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});
